<template>
	<b-table
		id="operators-table"
		:items="operators"
		:fields="fields"
		striped
		hover
		responsive
		show-empty
		empty-text="Nenhum operador encontrado"
		sticky-header
		:style="{ 'max-height': '100%', 'font-size': '14px' }"
	>
		<template #head(name)="data">
			<span class="whitespace-nowrap">
				<i class="fas fa-user"></i>
				{{ data.label }}
			</span>
		</template>

		<template #head(extension_line)="data">
			<span class="whitespace-nowrap">
				<i class="fas fa-phone-square"></i>
				{{ data.label }}
			</span>
		</template>
		
		<template #head(received)="data">
			<span class="whitespace-nowrap">
				<i class="fas fa-phone"></i>
				{{ data.label }}
			</span>
		</template>
		
		<template #head(answered)="data">
			<span class="whitespace-nowrap">
				<i class="fas fa-phone-volume"></i>
				{{ data.label }}
			</span>
		</template>
		
		<template #head(outgoing)="data">
			<span class="whitespace-nowrap">
				<i class="fas fa-phone-alt"></i>
				{{ data.label }}
			</span>
		</template>
		
		<template #head(notAnswered)="data">
			<span class="whitespace-nowrap">
				<i class="fas fa-phone-slash"></i>
				{{ data.label }}
			</span>
		</template>
		
		<template #head(attendanceTime)="data">
			<span class="whitespace-nowrap">
				<i class="fas fa-clock"></i>
				{{ data.label }}
			</span>
		</template>

		<template #cell(attendanceTime)="data">
			{{ parseTma(data.item.attendanceTime, data.item.answered, data.item.outgoing) }}
		</template>
	</b-table>
</template>

<script>
import axios from "axios";
import moment from 'moment'

export default {
	props: ["filter", "data"],
	data: function() {
		return {
			loading: false,
			startDate: moment().format('YYYY-MM-DD 00:00:00'),
			endDate: moment().format('YYYY-MM-DD 23:59:59'),
			fields: [
				{
					key: 'name',
					label: 'Operador',
					thClass: ['custom-column', 'name-header'],
					tdClass: ['font-weight-bold', 'vertical-align-middle'],
					sortable: false
				},
				{
					key: 'extension_line',
					label: 'Ramal',
					thClass: ['custom-column', 'extension-header'],
					tdClass: ['text-center', 'vertical-align-middle'],
					sortable: false
				},
				{
					key: 'received',
					label: 'Recebidas',
					thClass: ['custom-column', 'received-header'],
					tdClass: ['text-center', 'vertical-align-middle'],
					sortable: false
				},
				{
					key: 'answered',
					label: 'Atendidas',
					thClass: ['custom-column', 'answered-header'],
					tdClass: ['text-center', 'vertical-align-middle'],
					sortable: false
				},
				{
					key: 'outgoing',
					label: 'Realizadas',
					thClass: ['custom-column', 'outgoing-header'],
					tdClass: ['text-center', 'vertical-align-middle'],
					sortable: false
				},
				{
					key: 'notAnswered',
					label: 'Perdidas',
					thClass: ['custom-column', 'not-answered-header'],
					tdClass: ['text-center', 'vertical-align-middle'],
					sortable: false
				},
				{
					key: 'attendanceTime',
					label: 'TMA',
					thClass: ['custom-column', 'time-header'],
					tdClass: ['text-center', 'vertical-align-middle'],
					sortable: false
				}
			]
		};
	},
	computed: {
		operators(){
			return Object.values(this.data);
		}
	},
	methods: {
		formatDuration(seconds) {
			const duration = moment.duration(seconds, 'seconds');
    		const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
    		const minutes = duration.minutes().toString().padStart(2, '0');
    		const secs = duration.seconds().toString().padStart(2, '0');
    
    		return `${hours}:${minutes}:${secs}`;
		},
		parseTma(seconds, answered, outgoing){
			let tma = 0;
			if(answered > 0 || outgoing > 0){
				tma = (seconds / (answered + outgoing)).toFixed(2)
			}
			return this.formatDuration(tma);
		}
	}
};
</script>

<style lang="scss">
#operators-table {
	.custom-column {
		text-align: center;
		color: white !important;
	}

	.name-header {
		background-color: #323031 !important;
		border-radius: 10px 0 0 0;
	}

	.received-header {
		background-color: #023e8a !important;
	}

	.extension-header {
		background-color: gray !important;
	}

	.answered-header {
		background-color: #0ead69 !important;
	}

	.outgoing-header {
		background-color: #7b2cbf !important;
	}

	.not-answered-header {
		background-color: #ef233c !important;
	}

	.time-header {
		background-color: #ffb600 !important;
		border-radius: 0 10px 0 0;
	}

	.whitespace-nowrap {
		white-space: nowrap;
	}

	.vertical-align-middle {
		vertical-align: middle;
	}
}
</style>